import config from '../../config';

const getIsProductionEnv = () => config.get('NODE_ENV') === 'production';

export default getIsProductionEnv;
